// extracted by mini-css-extract-plugin
export default {"truncateBranch":"PullRequestHeaderSummary-module__truncateBranch__blq1Eld","summaryContainer":"PullRequestHeaderSummary-module__summaryContainer__it2THio"};